import { createContext } from 'rax';
const NavContext = createContext({
    clsPrefix: '',
    model: 'solid',
    type: 'normal',
    size: 'medium',
    direction: 'ver',
    curSelectedKeys: [],
    onItemSelect: () => { },
});
export default NavContext;
